// React
import React, { useState, useEffect, useCallback } from "react";

// Kendo
import kendo from "@progress/kendo-ui";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Checkbox } from "@progress/kendo-react-inputs";
import { TimePicker } from "@progress/kendo-react-dateinputs";

// Css
import "./elderBehavior.css"
import styles from "./elderBehavior.module.css"

// Service
import { getUser, isAdmin, isDeveloper, isLogin } from "../../../service/authService";
import { getBehaviorList, getUserBehaviorList, updateUserBehavior } from "../../../service/mngt/elderService";
import { parseDate } from "../../../com/dateUtil";

// Component

const ElderBehaviorEdit = ({ conn, elderInfo, setElderInfo, getUserBehaviorListCallback }) => {

  const userInfo = getUser();

  // 데이터 저장
  const [data, setData] = useState({
    behaviorDefault: { behaviorTerm: "행동패턴 선택" , behaviorCode: null },
    behavior: null,
    behaviorList: [],
  })
  const [behaviorValue, setBehaviorValue] = useState({ behaviorCode: elderInfo.selectedRow.dataItem.behaviorCode, behaviorTerm: elderInfo.selectedRow.dataItem.behaviorTerm })

  // 데이터 상태
  const [dataState, setDataState] = useState({
    userId: elderInfo.selectedRow.dataItem.userId,
    dayofweek: elderInfo.selectedRow.dataItem.dayofweek,
    time: elderInfo.selectedRow.dataItem.time,
    behaviorCode: elderInfo.selectedRow.dataItem.behaviorCode,
    behaviorTerm: elderInfo.selectedRow.dataItem.behaviorTerm,
    behaviorTermOther: elderInfo.selectedRow.dataItem.behaviorTermOther,
    editId: userInfo.userId,
    editDtm: parseDate("yyyy-mm-dd hh:mm:ss", new Date()),
    residenceStatus: elderInfo.selectedRow.dataItem.residenceStatus,  

    // 리스트 다시 조회
    selectedDay: elderInfo.selectedRow.dataItem.dayofweek,
  })

  // 행동패턴 저장
  const saveBehavior = () => {
    if(dataState.behaviorCode === null || dataState.behaviorTerm === null) {
      kendo.alert("행동패턴을 선택해주세요.");
    } else {
      updateUserBehavior(conn, dataState).then(() => {
        kendo.alert("수정이 완료되었습니다.")
        getUserBehaviorList(conn, getUserBehaviorListCallback, getRejection, dataState);
        closeEvt();
      })

    }
  }

  // 행동패턴 수정 팝업 닫기
  const closeEvt = () => {
    setElderInfo(elderInfo => {
      const item = { ...elderInfo };
      item.behaviorEditInfo = false;
      return item;
    });
  };

  // 재실 여부
  const [checked, setChecked] = useState({
    checkedY: false,
    checkedN: false,
  })

  const handleChangeY = () => {
    setBehaviorValue({ behaviorTerm: "행동패턴 선택" , behaviorCode: null })
    setDataState(dataState => {
      const item = { ...dataState };
      item.behaviorCode = null;
      item.behaviorTerm = null;
      item.behaviorTermOther = null;
      return item;
    })
    setChecked(checked => {
      const item = { ...checked };
      item.checkedY = !checked.checkedY;
      return item;
    })
    if (checked.checkedN) {
      setChecked(checked => {
        const item = { ...checked };
        item.checkedN = false;
        return item;
      })
    }
    if (!checked.checkedY) {
      setDataState(dataState => {
        const item = { ...dataState };
        item.residenceStatus = 'Y';
        getBehaviorList(conn, getBehaviorListCallback, getRejection, item);
        return item;
      })
    } else {
      setData((data) => {
        const item = { ...data };
        item.behaviorList = [];
        return item;
      })
    }
  };

  const handleChangeN = () => {
    setBehaviorValue({ behaviorTerm: "행동패턴 선택" , behaviorCode: null })
    setDataState(dataState => {
      const item = { ...dataState };
      item.behaviorCode = null;
      item.behaviorTerm = null;
      item.behaviorTermOther = null;
      return item;
    })
    setChecked(checked => {
      const item = { ...checked };
      item.checkedN = !checked.checkedN;
      return item;
    })
    if (checked.checkedY) {
      setChecked(checked => {
        const item = { ...checked };
        item.checkedY = false;
        return item;
      })
    }
    if (!checked.checkedN) {
      setDataState(dataState => {
        const item = { ...dataState };
        item.residenceStatus = 'N';
        getBehaviorList(conn, getBehaviorListCallback, getRejection, item);
        return item;
      })
    } else {
      setData((data) => {
        const item = { ...data };
        item.behaviorList = [];
        return item;
      })
    }
  };

  // 행동패턴 데이터 불러오기
  const getBehaviorListCallback = result => {
    setData((data) => {
      const item = { ...data };
      item.behaviorList = result;
      return item;
    })
  }

  const getRejection = reject => {
    console.log("getRejection = ", reject);
  };

  // 행동패턴 선택
  const handleChangeBehavior = event => {
    setBehaviorValue({ behaviorCode: event.target.value.behaviorCode, behaviorTerm: event.target.value.behaviorTerm})
    dataState.behaviorCode = event.target.value.behaviorCode;
    dataState.behaviorTerm = event.target.value.behaviorTerm;
    setDataState((dataState) => {
      const item = { ...dataState };
      item.behaviorTermOther = null;
      return item;
    })
  }

  // 행동패턴 기타
  const behaviorTermOtherChange = event => {
    setDataState((dataState) => {
      const item = { ...dataState };
      item.behaviorTermOther = event.target.value;
      return item;
    })
    // dataState.behaviorTermOther = event.target.value;
  }

  useEffect(() => {
    getBehaviorList(conn, getBehaviorListCallback, getRejection, dataState);
    if(elderInfo.selectedRow.dataItem.residenceStatus === "Y") {
      setChecked(checked => {
        const item = { ...checked };
        item.checkedY = true;
        return item;
      })
    } else if(elderInfo.selectedRow.dataItem.residenceStatus === "N") {
      setChecked(checked => {
        const item = { ...checked };
        item.checkedN = true;
        return item;
      })
    }
  }, []);




  return (
    <Dialog title={"행동패턴 수정 (" + elderInfo.selectedRow.dataItem.dayofweek + " " + elderInfo.selectedRow.dataItem.time + "시)"} onClose={closeEvt}>
      <div className={styles.behaviorEditDialog}>
        <div className={styles.category2}>
          <span className={styles.residenceStatusSpan}>재실여부</span>
          <Checkbox className={styles.residenceStatusCheckbox} label="Y" checked={checked.checkedY} onChange={handleChangeY} />
          <Checkbox className={styles.residenceStatusCheckbox} label="N" checked={checked.checkedN} onChange={handleChangeN} />
        </div>
        <div className={styles.category}>
          <DropDownList
            className={styles.behaviorListDropdown}
            data={data.behaviorList}
            textField = "behaviorTerm" 
            dataItemKey="behaviorCode"
            defaultItem={data.behaviorDefault}
            disabled={data.behaviorList.length === 0 && checked.checkedY === false && checked.checkedN === false}
            onChange={handleChangeBehavior}
            value={behaviorValue}
          />
        </div>
        {dataState.behaviorTerm === "기타" &&
          <div className={styles.category}>
            <input className={styles.behaviorTermOtherInput} type="text" value={dataState.behaviorTermOther} onChange={behaviorTermOtherChange} placeholder="EX) 병원, 교회 등" />
          </div>
        }
        <div className={styles.categoryButton}>
          <Button onClick={saveBehavior}>수정</Button>
          <Button onClick={closeEvt}>취소</Button>
        </div>
      </div>
    </Dialog>
  );
};
export default ElderBehaviorEdit;
